/* eslint-disable @typescript-eslint/no-explicit-any */
export class BannerSize {
    width: number 
    height: number
    constructor(data:string|any) {
        switch(true) {
            case typeof(data) === 'string': {
                const parts: string[] = data.split(/x/gim);
                this.width = parseInt(parts[0],10)
                this.height = parseInt(parts[1],10)
            } break;
            case (typeof(data)!== 'undefined' && typeof(data.width)!== 'undefined' &&typeof(data.height) !== 'undefined'): {
                this.width = data.width
                this.height = data.height
            } break;
            default:{ this.width = 0; this.height = 0;} break;
        }
    }
}